import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { Workpaper } from '../types/workpaper';
import { AxiosError } from 'axios';
import { genColour } from './use-entity';

type GetWorkpaperResponse = {
    workpaper: Workpaper;
};

async function getWorkpaper(id?: string): Promise<GetWorkpaperResponse> {
    const { data } = await api.get(`/workpapers/${id}`);
    return {
        ...data,
        workpaper: { ...data.workpaper, entity: { ...data.workpaper.entity, avatarHexColour: genColour(data.workpaper.entity.id) } },
    };
}

export function useWorkpaper(id?: string): UseQueryResult<GetWorkpaperResponse, AxiosError> {
    return useQuery(['workpapers', id], () => getWorkpaper(id), {
        keepPreviousData: false,
        enabled: Boolean(id),
    });
}
